/**
 * Generated by orval v8.17.0 🍺
 * Do not edit manually.
 * Server, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  DocumentDto,
  DocumentUploadDto,
  HttpValidationProblemDetails,
  ProblemDetails,
  ProjectDto,
  ProjectUploadDto
} from '../models';

import { customInstance } from '../../../orvalCustomAxiosInstance';
import type { ErrorType } from '../../../orvalCustomAxiosInstance';




/**
 * Add a document to a project
 */
export const postApiProjectsIdDocument = (
    id: string,
    documentUploadDto?: DocumentUploadDto,
 signal?: AbortSignal
) => {


      return customInstance<DocumentDto>(
      {url: `/api/Projects/${id}/document`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: documentUploadDto, signal
    },
      );
    }



export const getPostApiProjectsIdDocumentMutationOptions = <TError = ErrorType<ProblemDetails | HttpValidationProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiProjectsIdDocument>>, TError,{id: string;data?: DocumentUploadDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiProjectsIdDocument>>, TError,{id: string;data?: DocumentUploadDto}, TContext> => {

const mutationKey = ['postApiProjectsIdDocument'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiProjectsIdDocument>>, {id: string;data?: DocumentUploadDto}> = (props) => {
          const {id,data} = props ?? {};

          return  postApiProjectsIdDocument(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiProjectsIdDocumentMutationResult = NonNullable<Awaited<ReturnType<typeof postApiProjectsIdDocument>>>
    export type PostApiProjectsIdDocumentMutationBody = DocumentUploadDto | undefined
    export type PostApiProjectsIdDocumentMutationError = ErrorType<ProblemDetails | HttpValidationProblemDetails>

    export const usePostApiProjectsIdDocument = <TError = ErrorType<ProblemDetails | HttpValidationProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiProjectsIdDocument>>, TError,{id: string;data?: DocumentUploadDto}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiProjectsIdDocument>>,
        TError,
        {id: string;data?: DocumentUploadDto},
        TContext
      > => {
      return useMutation(getPostApiProjectsIdDocumentMutationOptions(options), queryClient);
    }
    /**
 * Archive an existing project
 */
export const putApiProjectsArchiveId = (
    id: string,
 signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/api/Projects/archive/${id}`, method: 'PUT', signal
    },
      );
    }



export const getPutApiProjectsArchiveIdMutationOptions = <TError = ErrorType<ProblemDetails | HttpValidationProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiProjectsArchiveId>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putApiProjectsArchiveId>>, TError,{id: string}, TContext> => {

const mutationKey = ['putApiProjectsArchiveId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putApiProjectsArchiveId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  putApiProjectsArchiveId(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutApiProjectsArchiveIdMutationResult = NonNullable<Awaited<ReturnType<typeof putApiProjectsArchiveId>>>

    export type PutApiProjectsArchiveIdMutationError = ErrorType<ProblemDetails | HttpValidationProblemDetails>

    export const usePutApiProjectsArchiveId = <TError = ErrorType<ProblemDetails | HttpValidationProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiProjectsArchiveId>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putApiProjectsArchiveId>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getPutApiProjectsArchiveIdMutationOptions(options), queryClient);
    }
    /**
 * Add a project
 */
export const postApiProjects = (
    projectUploadDto?: ProjectUploadDto,
 signal?: AbortSignal
) => {


      return customInstance<ProjectDto>(
      {url: `/api/Projects`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: projectUploadDto, signal
    },
      );
    }



export const getPostApiProjectsMutationOptions = <TError = ErrorType<ProblemDetails | HttpValidationProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiProjects>>, TError,{data?: ProjectUploadDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiProjects>>, TError,{data?: ProjectUploadDto}, TContext> => {

const mutationKey = ['postApiProjects'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiProjects>>, {data?: ProjectUploadDto}> = (props) => {
          const {data} = props ?? {};

          return  postApiProjects(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiProjectsMutationResult = NonNullable<Awaited<ReturnType<typeof postApiProjects>>>
    export type PostApiProjectsMutationBody = ProjectUploadDto | undefined
    export type PostApiProjectsMutationError = ErrorType<ProblemDetails | HttpValidationProblemDetails>

    export const usePostApiProjects = <TError = ErrorType<ProblemDetails | HttpValidationProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiProjects>>, TError,{data?: ProjectUploadDto}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiProjects>>,
        TError,
        {data?: ProjectUploadDto},
        TContext
      > => {
      return useMutation(getPostApiProjectsMutationOptions(options), queryClient);
    }
    /**
 * Get all projects in the system.
 */
export const getApiProjects = (

 signal?: AbortSignal
) => {


      return customInstance<ProjectDto[]>(
      {url: `/api/Projects`, method: 'GET', signal
    },
      );
    }




export const getGetApiProjectsQueryKey = () => {
    return [
    `/api/Projects`
    ] as const;
    }


export const getGetApiProjectsQueryOptions = <TData = Awaited<ReturnType<typeof getApiProjects>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiProjects>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiProjectsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiProjects>>> = ({ signal }) => getApiProjects(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiProjects>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiProjectsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiProjects>>>
export type GetApiProjectsQueryError = ErrorType<unknown>


export function useGetApiProjects<TData = Awaited<ReturnType<typeof getApiProjects>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiProjects>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiProjects>>,
          TError,
          Awaited<ReturnType<typeof getApiProjects>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiProjects<TData = Awaited<ReturnType<typeof getApiProjects>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiProjects>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiProjects>>,
          TError,
          Awaited<ReturnType<typeof getApiProjects>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiProjects<TData = Awaited<ReturnType<typeof getApiProjects>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiProjects>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiProjects<TData = Awaited<ReturnType<typeof getApiProjects>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiProjects>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiProjectsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






/**
 * Delete an archived project
 */
export const deleteApiProjectsId = (
    id: string,
 signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/api/Projects/${id}`, method: 'DELETE', signal
    },
      );
    }



export const getDeleteApiProjectsIdMutationOptions = <TError = ErrorType<ProblemDetails | HttpValidationProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiProjectsId>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteApiProjectsId>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteApiProjectsId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteApiProjectsId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteApiProjectsId(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteApiProjectsIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiProjectsId>>>

    export type DeleteApiProjectsIdMutationError = ErrorType<ProblemDetails | HttpValidationProblemDetails>

    export const useDeleteApiProjectsId = <TError = ErrorType<ProblemDetails | HttpValidationProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiProjectsId>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteApiProjectsId>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDeleteApiProjectsIdMutationOptions(options), queryClient);
    }
    /**
 * Get a single project by ID.
 */
export const getApiProjectsId = (
    id: string,
 signal?: AbortSignal
) => {


      return customInstance<ProjectDto>(
      {url: `/api/Projects/${id}`, method: 'GET', signal
    },
      );
    }




export const getGetApiProjectsIdQueryKey = (id: string,) => {
    return [
    `/api/Projects/${id}`
    ] as const;
    }


export const getGetApiProjectsIdQueryOptions = <TData = Awaited<ReturnType<typeof getApiProjectsId>>, TError = ErrorType<ProblemDetails | HttpValidationProblemDetails>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiProjectsId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiProjectsIdQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiProjectsId>>> = ({ signal }) => getApiProjectsId(id, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiProjectsId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiProjectsIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiProjectsId>>>
export type GetApiProjectsIdQueryError = ErrorType<ProblemDetails | HttpValidationProblemDetails>


export function useGetApiProjectsId<TData = Awaited<ReturnType<typeof getApiProjectsId>>, TError = ErrorType<ProblemDetails | HttpValidationProblemDetails>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiProjectsId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiProjectsId>>,
          TError,
          Awaited<ReturnType<typeof getApiProjectsId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiProjectsId<TData = Awaited<ReturnType<typeof getApiProjectsId>>, TError = ErrorType<ProblemDetails | HttpValidationProblemDetails>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiProjectsId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiProjectsId>>,
          TError,
          Awaited<ReturnType<typeof getApiProjectsId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiProjectsId<TData = Awaited<ReturnType<typeof getApiProjectsId>>, TError = ErrorType<ProblemDetails | HttpValidationProblemDetails>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiProjectsId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiProjectsId<TData = Awaited<ReturnType<typeof getApiProjectsId>>, TError = ErrorType<ProblemDetails | HttpValidationProblemDetails>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiProjectsId>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiProjectsIdQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






/**
 * Update an existing project
 */
export const putApiProjectsId = (
    id: string,
    projectUploadDto?: ProjectUploadDto,
 signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/api/Projects/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: projectUploadDto, signal
    },
      );
    }



export const getPutApiProjectsIdMutationOptions = <TError = ErrorType<ProblemDetails | HttpValidationProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiProjectsId>>, TError,{id: string;data?: ProjectUploadDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putApiProjectsId>>, TError,{id: string;data?: ProjectUploadDto}, TContext> => {

const mutationKey = ['putApiProjectsId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putApiProjectsId>>, {id: string;data?: ProjectUploadDto}> = (props) => {
          const {id,data} = props ?? {};

          return  putApiProjectsId(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutApiProjectsIdMutationResult = NonNullable<Awaited<ReturnType<typeof putApiProjectsId>>>
    export type PutApiProjectsIdMutationBody = ProjectUploadDto | undefined
    export type PutApiProjectsIdMutationError = ErrorType<ProblemDetails | HttpValidationProblemDetails>

    export const usePutApiProjectsId = <TError = ErrorType<ProblemDetails | HttpValidationProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiProjectsId>>, TError,{id: string;data?: ProjectUploadDto}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putApiProjectsId>>,
        TError,
        {id: string;data?: ProjectUploadDto},
        TContext
      > => {
      return useMutation(getPutApiProjectsIdMutationOptions(options), queryClient);
    }
    /**
 * Get archived projects in the system.
 */
export const getApiProjectsArchive = (

 signal?: AbortSignal
) => {


      return customInstance<ProjectDto[]>(
      {url: `/api/Projects/archive`, method: 'GET', signal
    },
      );
    }




export const getGetApiProjectsArchiveQueryKey = () => {
    return [
    `/api/Projects/archive`
    ] as const;
    }


export const getGetApiProjectsArchiveQueryOptions = <TData = Awaited<ReturnType<typeof getApiProjectsArchive>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiProjectsArchive>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiProjectsArchiveQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiProjectsArchive>>> = ({ signal }) => getApiProjectsArchive(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiProjectsArchive>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiProjectsArchiveQueryResult = NonNullable<Awaited<ReturnType<typeof getApiProjectsArchive>>>
export type GetApiProjectsArchiveQueryError = ErrorType<unknown>


export function useGetApiProjectsArchive<TData = Awaited<ReturnType<typeof getApiProjectsArchive>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiProjectsArchive>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiProjectsArchive>>,
          TError,
          Awaited<ReturnType<typeof getApiProjectsArchive>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiProjectsArchive<TData = Awaited<ReturnType<typeof getApiProjectsArchive>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiProjectsArchive>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiProjectsArchive>>,
          TError,
          Awaited<ReturnType<typeof getApiProjectsArchive>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiProjectsArchive<TData = Awaited<ReturnType<typeof getApiProjectsArchive>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiProjectsArchive>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiProjectsArchive<TData = Awaited<ReturnType<typeof getApiProjectsArchive>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiProjectsArchive>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiProjectsArchiveQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






/**
 * Restore an archived project
 */
export const putApiProjectsArchiveRestoreId = (
    id: string,
 signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/api/Projects/archive/restore/${id}`, method: 'PUT', signal
    },
      );
    }



export const getPutApiProjectsArchiveRestoreIdMutationOptions = <TError = ErrorType<ProblemDetails | HttpValidationProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiProjectsArchiveRestoreId>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putApiProjectsArchiveRestoreId>>, TError,{id: string}, TContext> => {

const mutationKey = ['putApiProjectsArchiveRestoreId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putApiProjectsArchiveRestoreId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  putApiProjectsArchiveRestoreId(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutApiProjectsArchiveRestoreIdMutationResult = NonNullable<Awaited<ReturnType<typeof putApiProjectsArchiveRestoreId>>>

    export type PutApiProjectsArchiveRestoreIdMutationError = ErrorType<ProblemDetails | HttpValidationProblemDetails>

    export const usePutApiProjectsArchiveRestoreId = <TError = ErrorType<ProblemDetails | HttpValidationProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiProjectsArchiveRestoreId>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putApiProjectsArchiveRestoreId>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getPutApiProjectsArchiveRestoreIdMutationOptions(options), queryClient);
    }
